import SitePath from './site-path';

export default SitePath;